import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 264,
    marginBottom: 100,
  },
  title: {
    marginBottom: 40,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  sub: {
    marginTop: 24,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  regular: {
    fontWeight: 400,
  },
  bold: {
    fontWeight: 600,
  },

  bodybol: {
    marginTop: 32,
    marginBottom: 32,
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
  },

  footer: {
    marginTop: 12,
    marginBottom: 36,
  },
}));

const FormList = ({
  cancer = "유방암",
  onPageChange,
  onLinkHome,
  score,
  onChange,
}) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        container
        justify="center"
        alignItems="center"
        direction="column"
        className={classes.header}
      >
        <Typography variant="h2" align="center" className={classes.title}>
          <span className={classes.regular}>
            나의 {cancer}&nbsp;위험도 계산을 마쳤습니다.
          </span>
        </Typography>

        <Typography
          variant="h4"
          color="textSecondary"
          align="center"
          className={classes.sub}
        >
          계산하신 귀하의 {cancer} 위험도를 참고해주시고,
          <br />
          <span className={classes.bold}>
            “{cancer} 조기 검진 받는 것이 좋을까요?”
          </span>{" "}
          안내 영상을 통해
          <br />
          검진을 받을지 여부를 결정하시기 바랍니다.
        </Typography>
      </Grid>
    </>
  );
};

export default FormList;
